import { Component, ElementRef, EventEmitter, Inject, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Observable, fromEvent, merge } from 'rxjs';
import { switchMap, takeUntil, pairwise, tap } from 'rxjs/operators';
import { StandardFile } from 'src/app/classes/shared/file/file';
import { getIP } from 'src/app/modules/jobseeker-registration/services/registration/jobseeker-registration.service';
import { FilesService } from 'src/app/services/shared/files/files.service';
import { NotificationService } from 'src/app/services/shared/notification/notification.service';
import { localToUTC, storage_url } from '../../functions/shared-functions';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { dataURLtoFile } from '../tm-dynamic-form-v3/tm-dynamic-form-v3.component';
import { SignatureModalComponent } from './signature-modal/signature-modal.component';

@Component({
  selector: 'tm-digital-signature',
  templateUrl: './tm-digital-signature.component.html',
  styleUrls: ['./tm-digital-signature.component.scss'],
  providers: [FilesService]
})
export class TmDigitalSignatureComponent implements OnInit {


  public canvas: ElementRef;

  @ViewChild('canvas_container', { static: true }) public canvas_container: ElementRef;
  // setting a width and height for the canvas
  @Input() public width = 400;
  @Input() public height = 400;
  @Input() public label = "Digital Signature";
  @Input() public placeholder = "Please sign here using mouse/finger/stylus/digital pen";
  @Input() field;
  @Input() type;
  @Input() value;
  @Input() id = Math.random() * 1000 + Date.now();
  @Input() style;
  @Input() class;
  @Input() hint;
  @Input() control_type;
  @Input() required;
  @Input() error_msg;
  @Input() controlName;
  @Input() ngModel;
  @Input() verified_status;
  @Input() notes;
  @Input() reason;
  @Input() verification_required;
  @Input() hide_label;
  @Output() getValue = new EventEmitter();
  @Input() label_block;
  @Input() context_menu_listner;
  @Input() on_change_listner;
  @Input() html_decode;
  @Input() disabled;
  @Input() enable_manual_upload;
  @Input() form_group;
  @Input() form_control;

  @Input() ip_control_name;
  @Input() place_control_name;
  supported_files = ["JPEG", "JPG", "PNG"];
  storage_url = storage_url;
  // ngAfterViewInitRef = this.ngAfterViewInit.bind(this);
  showBase64 = 0;
  ip_details = getIP()
  private cx: CanvasRenderingContext2D;

  constructor(
    private file_service: FilesService,
    private notification_srv: NotificationService,
    private dialog: MatDialog
  ) {

  }
  ngOnInit(): void {
    if (this.field?.ipFieldID && !(this.form_group.get(this.field.ipFieldID) && this.form_group.get(this.field.ipFieldID).value)) {
      this.form_group.get(this.field.ipFieldID).patchValue(this.ip_details.ip);
    }
    if (this.field?.ipFieldID && !(this.form_group.get(this.field.placeFieldID) && this.form_group.get(this.field.placeFieldID).value)) {
      this.form_group.get(this.field.placeFieldID).patchValue(this.ip_details.city);
    }
    if (this.field?.ipFieldID && !(this.form_group.get(this.field.dateFieldID) && this.form_group.get(this.field.dateFieldID).value)) {
      this.form_group.get(this.field.dateFieldID).patchValue(localToUTC(new Date()));
    }


  }

  // public ngAfterViewInit() {
  //   try {
  //     // get the context
  //     const canvasEl: HTMLCanvasElement = this.canvas.nativeElement;
  //     this.cx = canvasEl.getContext('2d');

  //     // set the width and height

  //     let width = getComputedStyle(this.canvas_container.nativeElement).getPropertyValue('width')
  //     let height = getComputedStyle(this.canvas_container.nativeElement).getPropertyValue('height')
  //     // canvasEl.width = parseInt(width) - 20 || 200;
  //     // canvasEl.height = parseInt(height) - 20 || 150;

  //     // set some default properties about the line
  //     this.cx.lineWidth = 3;
  //     this.cx.lineCap = 'round';
  //     this.cx.strokeStyle = '#000';

  //     // we'll implement this method to start capturing mouse events
  //     this.captureEvents(canvasEl);
  //   }
  //   catch (err) {

  //   }
  // }

  // private captureEvents(canvasEl: HTMLCanvasElement) {
  //   // this will capture all mousedown events from the canvas element
  //   fromEvent(canvasEl, 'mousedown').pipe(switchMap((e) => {
  //     // after a mouse down, we'll record all mouse moves
  //     return fromEvent(canvasEl, 'mousemove').pipe(
  //       // we'll stop (and unsubscribe) once the user releases the mouse
  //       // this will trigger a 'mouseup' event
  //       takeUntil(fromEvent(canvasEl, 'mouseup')),
  //       // we'll also stop (and unsubscribe) once the mouse leaves the canvas (mouseleave event)
  //       takeUntil(fromEvent(canvasEl, 'mouseleave')),
  //       // pairwise lets us get the previous value to draw a line from
  //       // the previous point to the current point
  //       pairwise()
  //     )
  //   })
  //   ).subscribe((res: [MouseEvent, MouseEvent]) => {
  //     const rect = canvasEl.getBoundingClientRect();
  //     // previous and current position with the offset
  //     const prevPos = {
  //       x: res[0].clientX - rect.left,
  //       y: res[0].clientY - rect.top
  //     };

  //     const currentPos = {
  //       x: res[1].clientX - rect.left,
  //       y: res[1].clientY - rect.top
  //     };

  //     // this method we'll implement soon to do the actual drawing
  //     this.drawOnCanvas(prevPos, currentPos);
  //   });
  // }

  // private captureEvents(canvasEl: HTMLCanvasElement) {
  //   // this will capture all mousedown/touchstart events from the canvas element
  //   merge(fromEvent(canvasEl, 'mousedown'), fromEvent(canvasEl, 'touchstart')).pipe(switchMap((e) => {
  //     // after a mouse/touch start, we'll record all mouse/touch moves
  //     const moveEvent = e.type === 'mousedown' ? 'mousemove' : 'touchmove';
  //     return merge(fromEvent(canvasEl, moveEvent).pipe(
  //       // we'll stop (and unsubscribe) once the user releases the mouse/touch
  //       // this will trigger a 'mouseup'/'touchend' event
  //       takeUntil(merge(fromEvent(canvasEl, e.type === 'mousedown' ? 'mouseup' : 'touchend'), fromEvent(canvasEl, 'mouseleave'))),
  //       // pairwise lets us get the previous value to draw a line from
  //       // the previous point to the current point
  //       pairwise()
  //     ),
  //       // Prevent touch event default behavior to disable scrolling
  //       fromEvent(canvasEl, 'touchmove').pipe(
  //         tap((e: TouchEvent) => {
  //           e.preventDefault();
  //         })
  //       )
  //     );
  //   })
  //   ).subscribe((res: [MouseEvent | TouchEvent, MouseEvent | TouchEvent]) => {
  //     const rect = canvasEl.getBoundingClientRect();
  //     // previous and current position with the offset
  //     const prevPos = {
  //       x: (res[0] instanceof MouseEvent) ? (res[0] as MouseEvent).clientX - rect.left : (res[0] as TouchEvent).touches[0].clientX - rect.left,
  //       y: (res[0] instanceof MouseEvent) ? (res[0] as MouseEvent).clientY - rect.top : (res[0] as TouchEvent).touches[0].clientY - rect.top
  //     };

  //     const currentPos = {
  //       x: (res[1] instanceof MouseEvent) ? (res[1] as MouseEvent).clientX - rect.left : (res[1] as TouchEvent).touches[0].clientX - rect.left,
  //       y: (res[1] instanceof MouseEvent) ? (res[1] as MouseEvent).clientY - rect.top : (res[1] as TouchEvent).touches[0].clientY - rect.top
  //     };

  //     // this method we'll implement soon to do the actual drawing
  //     this.drawOnCanvas(prevPos, currentPos);
  //   });
  // }




  // private drawOnCanvas(
  //   prevPos: { x: number, y: number },
  //   currentPos: { x: number, y: number }
  // ) {
  //   // incase the context is not set
  //   if (!this.cx) { return; }

  //   // start our drawing path
  //   this.cx.beginPath();

  //   // we're drawing lines so we need a previous position
  //   if (prevPos) {
  //     // sets the start point
  //     this.cx.moveTo(prevPos.x, prevPos.y); // from

  //     // draws a line from the start pos until the current position
  //     this.cx.lineTo(currentPos.x, currentPos.y);

  //     // strokes the current path with the styles we set earlier
  //     this.cx.stroke();
  //     var jpegUrl = this.canvas.nativeElement.toDataURL("image/jpeg");
  //     var pngUrl = this.canvas.nativeElement.toDataURL();
  //     let file = new StandardFile();
  //     file.setFileDetails('signature.png', 'image/png', pngUrl, 'png', 1, '', '', '', '');
  //     this.form_group.get(this.form_control).setValue(file);
  //     console.log(file);
  //   }
  // }

  clearCanvas() {
    try {
      const canvasEl: HTMLCanvasElement = this.canvas.nativeElement;
      let width = getComputedStyle(this.canvas_container.nativeElement).getPropertyValue('width')
      let height = getComputedStyle(this.canvas_container.nativeElement).getPropertyValue('height')
      canvasEl.width = parseInt(width) - 20 || 400;
      canvasEl.height = parseInt(height) - 20 || 400;
      this.cx.lineWidth = 3;
      this.cx.lineCap = 'round';
      this.cx.strokeStyle = '#000';
      this.cx.clearRect(0, 0, canvasEl.width, canvasEl.height);

    }
    catch (err) {

    }
    this.showBase64 = 0;
    if (this.field.ipFieldID) {
      this.form_group.get(this.field.ipFieldID).patchValue(this.ip_details.ip);
    }
    if (this.field.placeFieldID) {
      this.form_group.get(this.field.placeFieldID).patchValue(this.ip_details.city);
    }
    if (this.field.dateFieldID) {
      this.form_group.get(this.field.dateFieldID).patchValue(localToUTC(new Date()));
    }
    this.form_group.get(this.form_control).setValue(null);
  }

  fileInputChanged(files) {


    console.log(files)
    if (files && files.length > 20) {
      this.notification_srv.success('Please wait while valid attachment list is being prepared', 'Close', 5000)
    }
    this.file_service.convertFilesToBase64(files).subscribe(res => {
      let all_files = res as any;
      this.showBase64 = 1;
      all_files.forEach(f => {

        if (this.supported_files.findIndex(data =>
          (data).toLocaleLowerCase() == (f.extension).toLocaleLowerCase()) > -1) {
          if (f.size < (10242880)) {
            this.form_group.get(this.form_control).setValue(f);
            console.log(f);
            // drawImage()
          }
          else {
            this.notification_srv.error('File size must be less than 10 MB', 'Close', 5000);
          }
        }
        else {
          this.notification_srv.error(f.fileName + ' ' + 'not supported.' + ' Supported file types:-' + this.supported_files.toString(), 'Close', 5000);
        }
      })
    })

  }

  openSignatureModal(form_group, height, form_control, field, disabled) {
    let dialogRef = this.dialog.open(SignatureModalComponent,
      {
        width: '40%',
        height: 'fit-content'
      })
    dialogRef.componentInstance.form_group = form_group;
    dialogRef.componentInstance.height = height;
    dialogRef.componentInstance.field = field;
    dialogRef.componentInstance.form_control = form_control;
    dialogRef.componentInstance.disabled = disabled;
    dialogRef.afterClosed().subscribe(resp => {
      if (resp) {
        this.uploadDocument(resp).subscribe(res => {
          if (res) {
            form_group.get(form_control).patchValue(res);
          }
        })
      }
    })
  }

  uploadDocument(file_obj, file_name = "digital-sign.png") {
    return new Observable(obs => {
      // if (type == 1) {
      try {
        let base64;
        let file_title;
        let mime_type;
        try {
          base64 = (file_obj.base64 ? file_obj.base64 : file_obj.content);
          file_title = (file_obj.fileName);
          mime_type = (file_obj.mimeType);
        }
        catch (err) {

        }

        if (base64) {
          base64 = base64;
        }
        else {
          base64 = file_obj;
        }
        if (file_title) {
          file_name = file_title;
        }

        let file = dataURLtoFile(base64, file_name)
        let form_data = new FormData();
        form_data.append('attachment', file, file.name);
        this.notification_srv.success('FILES.uploading_attachments', 'Close', 3000);
        this.file_service.uploadAttachment(form_data, "1").subscribe(res => {

          let attach = {}
          if (res && res['data']) {

            attach['fileName'] = res['data']['a_fn'];
            attach['cdnPath'] = res['data']["a_url"];

            obs.next([attach]);
            this.notification_srv.success(res['message'], 'Close', 3000);
            // attach['width'] = this.result_dimentions[0].width
            // attach['height'] = this.result_dimentions[0].heigh
          }
          else {
            obs.next(0)
            this.notification_srv.error(res && res['message'], 'Close', 3000);
          }
        }, err => {
          obs.next(0);
        })
      } catch (error) {
        obs.next(0)
      }
      // }

    })
  }

}
